import React, { useState } from "react";
import {
    PageTitleText 
 } from '../../../../widget/styledComponents/headings.style';

import { gql } from '@apollo/client';

import { useParams } from "react-router-dom/cjs/react-router-dom.min";



export const RECEIVABLE_BY_ID = gql`
query Receivable_getById($receivableGetByIdId: ID!) {
  receivable_getById(id: $receivableGetByIdId) {
    _id
    property
    amount
    description
    appliesToBills
    bills
    receivedFrom
    receivedFromType
    receivedOn
    reference
    createdAt
    id
  }
}
`;

function PropertyPageReceivableByIdWidget() {
const {id} = useParams()
// const { loading,data }  = useQuery(RECEIVABLE_BY_ID,{
//     variables: {
//         receivableGetByIdId: id,
//      },
// });

const [showPropertyDetails,setShowPropertyDetails] = useState(false)



  return (
    <div>
        {showPropertyDetails &&
        <div>
            <br/><br/>
            <div className='row'>
                <div className='col s12 ' style={{
                    display:"flex"
                }}>
                    <span className='center' style={{
                            width:"30px",
                            height:"30px",
                            cursor: "pointer"
                        }}
                            onClick={()=>setShowPropertyDetails(false) }

                        >
                            <i className='material-icons center'>arrow_backwards</i>
                        </span>
                    <PageTitleText>
                        {id}
                    </PageTitleText>
                </div>
                
            </div>
        </div>
        }

    </div>
  )
}

export default PropertyPageReceivableByIdWidget














